<template>
  <div class="mb-4">
    <ul class="nav nav-pills nav-justified">
      <li class="nav-item waves-effect waves-light">
        <router-link
          class="nav-link"
          :class="{ 
            active: seccion == 'planes'
          }"
          :to="{ name: 'listadoPlanesServicio' }"
        >
          <span class="d-block d-sm-none">
            Planes
          </span>
          <span class="d-none d-sm-block">
            Planes de servicio
          </span>
        </router-link>
      </li>
      <li class="nav-item waves-effect waves-light">
        <router-link
          :to="{ name: 'listadoPerfilesVelocidad' }"
          class="nav-link"
          :class="{ 
            active: seccion == 'perfiles'
          }"
        >
          <span class="d-block d-sm-none">
            Perfiles
          </span>
          <span class="d-none d-sm-block">
            Perfiles de velocidad
          </span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'CmpSecciones',
  props: ['seccion'],
}
</script>

<style>
.no-cursor{
  cursor: default;
}
</style>